export default __webpack_public_path__ + "static/media/Carol Pefley.213eb3f3.jpg";